import { synthesizeDataWithJSONSchema } from '@criteria/synthetic-data';
import { exampleForMediaType } from './exampleForMediaType';
import { exampleQueryForParameter } from './exampleQueryForParameter';
export function formatCURL(endpoint) {
    var _a, _b, _c, _d, _e;
    const lines = [];
    const servers = (_a = endpoint.service.openAPI.servers) !== null && _a !== void 0 ? _a : [];
    const serverURL = servers.length > 0 && servers[0].url !== '/' ? servers[0].url : 'https://api.example.com';
    const path = (_b = endpoint.path) !== null && _b !== void 0 ? _b : '/callback';
    let url = `${serverURL}${path}`;
    const requiredQueryParameters = (_c = endpoint.operation.parameters) === null || _c === void 0 ? void 0 : _c.filter((parameter) => parameter.required && parameter.in === 'query');
    if (requiredQueryParameters && requiredQueryParameters.length > 0) {
        const queries = requiredQueryParameters.map((parameter) => `${parameter.name}=${exampleQueryForParameter(parameter)}`);
        url += `?${queries.join('&')}`;
    }
    lines.push(`curl ${url}`);
    if (endpoint.method !== 'get') {
        lines.push(`  -X ${endpoint.method.toUpperCase()}`);
    }
    const headers = (_e = (_d = endpoint.operation.parameters) === null || _d === void 0 ? void 0 : _d.filter((parameter) => parameter.in === 'header')) !== null && _e !== void 0 ? _e : [];
    for (const header of headers) {
        lines.push(`  -H ${header.name}: ${header.schema ? synthesizeDataWithJSONSchema(header.schema) : '""'}`);
    }
    const content = endpoint.requestBodyContent();
    if (content !== undefined && content[1] !== undefined) {
        const example = exampleForMediaType(content[1]);
        lines.push(`  -H Content-Type: ${content[0]}`);
        const formattedJSON = JSON.stringify(example, null, '  ');
        lines.push(`  --data '${formattedJSON.replaceAll('\n', '\n  ')}'`);
    }
    return lines.map((line, index) => (index < lines.length - 1 ? `${line} \\` : line)).join('\n');
}
